/**
 * Convert airport IATA code to city name
 * This is a basic mapping for common airports
 */
export function getCityNameFromAirportCode(code: string): string {
  const airportToCity: { [key: string]: string } = {
    // Australia
    'PER': 'Perth',
    'SYD': 'Sydney',
    'MEL': 'Melbourne',
    'BNE': 'Brisbane',
    'ADL': 'Adelaide',
    'CBR': 'Canberra',
    'OOL': 'Gold Coast',
    'CNS': 'Cairns',
    
    // Singapore
    'SIN': 'Singapore',
    
    // UK
    'LHR': 'London',
    'LGW': 'London',
    'STN': 'London',
    'LTN': 'London',
    'DUB': 'Dublin',
    'EDI': 'Edinburgh',
    'MAN': 'Manchester',
    'BRS': 'Bristol',
    
    // Europe
    'CDG': 'Paris',
    'ORY': 'Paris',
    'MAD': 'Madrid',
    'BCN': 'Barcelona',
    'FCO': 'Rome',
    'MXP': 'Milan',
    'AMS': 'Amsterdam',
    'FRA': 'Frankfurt',
    'MUC': 'Munich',
    'DUS': 'Düsseldorf',
    'CGN': 'Cologne',
    'VIE': 'Vienna',
    'ZRH': 'Zurich',
    'GVA': 'Geneva',
    'BRU': 'Brussels',
    'LIS': 'Lisbon',
    'OPO': 'Porto',
    'ATH': 'Athens',
    'BUD': 'Budapest',
    'PRG': 'Prague',
    'WAW': 'Warsaw',
    'CPH': 'Copenhagen',
    'OSL': 'Oslo',
    'STO': 'Stockholm',
    'HEL': 'Helsinki',
    
    // Middle East
    'DOH': 'Doha',
    'DXB': 'Dubai',
    'AUH': 'Abu Dhabi',
    'TLV': 'Tel Aviv',
    'IST': 'Istanbul',
    
    // Asia
    'BKK': 'Bangkok',
    'KUL': 'Kuala Lumpur',
    'CGK': 'Jakarta',
    'MNL': 'Manila',
    'HKG': 'Hong Kong',
    'TPE': 'Taipei',
    'ICN': 'Seoul',
    'NRT': 'Tokyo',
    'HND': 'Tokyo',
    'PEK': 'Beijing',
    'PVG': 'Shanghai',
    'DEL': 'Delhi',
    'BOM': 'Mumbai',
    
    // North America
    'JFK': 'New York',
    'LGA': 'New York',
    'EWR': 'New York',
    'LAX': 'Los Angeles',
    'SFO': 'San Francisco',
    'ORD': 'Chicago',
    'MIA': 'Miami',
    'FLL': 'Fort Lauderdale',
    'LAS': 'Las Vegas',
    'DEN': 'Denver',
    'SEA': 'Seattle',
    'BOS': 'Boston',
    'IAD': 'Washington',
    'ATL': 'Atlanta',
    'DFW': 'Dallas',
    'IAH': 'Houston',
    'PHX': 'Phoenix',
    'CLT': 'Charlotte',
    'MSP': 'Minneapolis',
    'DTW': 'Detroit',
    'PHL': 'Philadelphia',
    'YYZ': 'Toronto',
    'YVR': 'Vancouver',
    
    // South America
    'GRU': 'São Paulo',
    'GIG': 'Rio de Janeiro',
    'EZE': 'Buenos Aires',
    'SCL': 'Santiago',
  };
  
  return airportToCity[code.toUpperCase()] || code;
}

